import { c as _c } from "react/compiler-runtime";
export const ChatKitArrowFilledIcon = props => {
  const $ = _c(6);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g filter="url(#filter0_d_2841_2749)"><path d="M35.5544 15.4543C36.1401 16.0399 36.1401 16.9892 35.5544 17.5748L26.557 27.5608C25.9714 28.1464 25.0221 28.1464 24.4365 27.5608L15.4391 17.5748C14.8535 16.9892 14.8535 16.0399 15.4391 15.4543C16.0247 14.8687 16.9258 14.8599 17.5596 15.4543L24.4481 21.1093C24.8081 21.4048 24.9881 21.5526 25.1886 21.6094C25.3655 21.6596 25.5527 21.66 25.7298 21.6107C25.9306 21.5548 26.1113 21.4079 26.4727 21.1141L33.4339 15.4543C34.047 14.8288 34.9688 14.8687 35.5544 15.4543Z" fill="white" /></g>;
    t1 = <path d="M35.0385 15.9374C35.4676 16.3665 35.4676 17.0621 35.0385 17.4913L26.2736 26.9799C25.8445 27.4091 25.1489 27.4091 24.7197 26.9799L15.9195 17.4913C15.4903 17.0621 15.4903 16.3665 15.9195 15.9374C16.3486 15.5082 17.0089 15.5018 17.4733 15.9374L24.4226 21.9544C24.7936 22.2757 24.9791 22.4363 25.1875 22.4975C25.3711 22.5515 25.5664 22.5516 25.7502 22.4979C25.9586 22.4369 26.1443 22.2765 26.5157 21.9558L33.4846 15.9374C33.9339 15.479 34.6094 15.5083 35.0385 15.9374Z" fill="url(#paint0_linear_2841_2749)" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <filter id="filter0_d_2841_2749" x="0" y="0" width="50.9937" height="43" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix" /><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" /><feOffset /><feGaussianBlur stdDeviation="7.5" /><feComposite in2="hardAlpha" operator="out" /><feColorMatrix type="matrix" values="0 0 0 0 0.910465 0 0 0 0 0.852314 0 0 0 0 1 0 0 0 1 0" /><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2841_2749" /><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2841_2749" result="shape" /></filter>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <defs>{t2}<linearGradient id="paint0_linear_2841_2749" x1="29.8812" y1="19.3209" x2="27.3633" y2="27.7725" gradientUnits="userSpaceOnUse"><stop stop-color="#4EB2F4" /><stop offset="0.211538" stop-color="#4076F9" /><stop offset="0.769231" stop-color="#7A3ADB" /></linearGradient></defs>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== props) {
    t4 = <svg width="51" height="43" viewBox="0 0 51 43" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}{t3}</svg>;
    $[4] = props;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};